import Vue from 'vue'
import Router from 'vue-router'
const login = () => import('@/components/login/login')
const home = () => import('@/components/home/home') /*主页 */
const menuList = () => import('@/components/menuList/menuList') /**全部功能 */
const todayReport = () => import('@/components/menuList/list/todayReport') /**今日报表 */
const monthReport = () => import('@/components/menuList/list/monthReport') /**运营报表 */
const salesDetails = () => import('@/components/menuList/list/salesDetails') /**销售细节 */
const deliveryRecord = () => import('@/components/menuList/list/deliveryRecord') /**出货记录 */
const wxNotice = () => import('@/components/menuList/list/wxNotice') /**出货记录 */
const aisleConfig = ()=> import('@/components/menuList/list/aisleConfig') /**货道配置 */
const aisleDetails = ()=> import('@/components/menuList/list/aisleDetails') /**货道细节 */
const setLocation = ()=> import('@/components/menuList/list/setLocation') /**修改地址*/
const changeGoods = ()=> import('@/components/menuList/list/changeGoods') /**货道的更改商品 */
const machineDetails = ()=> import('@/components/menuList/list/machineDetails')  /**设备详情 */
const machineCode = ()=> import('@/components/menuList/list/machineCode')  /**机器二维码 */
const paymentDetails = ()=> import('@/components/menuList/list/paymentDetails')  /**收支详情 */
const changeMachineInfo = ()=> import('@/components/menuList/list/changeMachineInfo')  /**修改或添加设备 */
const replenishment = ()=> import('@/components/menuList/list/replenishment')  /**补货主页 */
const replenishmentDetails = ()=> import('@/components/menuList/list/replenishmentDetails')  /**补货详细内容 */
const dataAnalysis = ()=> import('@/components/menuList/list/dataAnalysis')  /**数据分析主页 */
const salesStatistics = ()=> import('@/components/menuList/list/salesStatistics')  /**销售统计主页 */
const salesStatisticsDetails = ()=> import('@/components/menuList/list/salesStatisticsDetails')  /**销售统计详情页 */
const noncash = ()=> import('@/components/menuList/list/noncash')  /**非现金雪糕机主页 */
const allocation = ()=> import('@/components/menuList/list/allocation')  /**分配 */
const cashMachine = ()=> import('@/components/menuList/list/cashMachine')  /**现金雪糕机主页 */
const noCashDetail = ()=> import('@/components/menuList/list/noCashDetail')  /**非现金明细详情 */
const breakMachine = ()=> import('@/components/menuList/list/breakMachine')  /**雪糕机故障主页 */
const breakMissingDetails = ()=> import('@/components/menuList/list/breakMissingDetails')  /**失联详情 */
const breakStockoutDetails = ()=> import('@/components/menuList/list/breakStockoutDetails')  /**缺货详情 */
const breakAisleFaultDetails = ()=> import('@/components/menuList/list/breakAisleFaultDetails')  /**故障详情 */
const stockMachine = ()=> import('@/components/menuList/list/stockMachine')  /**雪糕机缺货主页 */
const stockStatistics = () => import('@/components/menuList/list/stockStatistics') /**缺货统计 */
const accountRankList = () => import('@/components/menuList/list/accountRankList') /**运营商排名 */
const salesChart = () => import('@/components/menuList/list/salesChart') /**销售趋势图 */

const setting = ()=> import('@/components/setting/setting')  /**设置主页 */
const requestWithdrawal = ()=> import('@/components/setting/requestWithdrawal')  /**申请提现 */
const renew = ()=> import('@/components/setting/renew')  /**设备续费 */
const renewConfirm = ()=> import('@/components/setting/renewConfirm')  /**确认续费 */
const renewBlank = ()=> import('@/components/setting/renewBlank')  /**续费跳转页 */
const changeBind = ()=> import('@/components/setting/changeBind')  /**更改绑定 */
const feedback = ()=> import('@/components/setting/feedback')  /**问题反馈 */
const withdrawDepositRecord = ()=> import('@/components/setting/withdrawDepositRecord')  /**提现记录 */
const changePassword = ()=> import('@/components/setting/changePassword')  /**修改密码 */

const service = ()=> import('@/components/setting/feedback/service'),  /** 客服管理*/
      reple = ()=> import('@/components/setting/feedback/body')  /**合集 */


const goodsList = ()=> import('@/components/menuList/list/goodsList')  /**商品列表 */
const addGoods = ()=> import('@/components/menuList/list/addGoods')  /**添加商品 */
const changeAlreadyGoods = ()=> import('@/components/menuList/list/changeAlreadyGoods')  /**修改商品 */

const vip = ()=> import('@/components/menuList/vip/vip')  /**会员卡首页 */
const vipDetails = ()=> import('@/components/menuList/vip/vipDetails')  /**会员卡详情 */
const cardReissue = ()=> import('@/components/menuList/vip/cardReissue')  /**补卡 */
const recharge = ()=> import('@/components/menuList/vip/recharge')  /**充值 */
const addVip = ()=> import('@/components/menuList/vip/addVip')  /**充值 */

const not404 = ()=> import('@/components/notFound/404'),
      not505 = ()=> import('@/components/notFound/505')


//二级路由
const breakMissing = ()=> import('@/components/menuList/list/breakMissing')  /**失联 */
const breakStockout = ()=> import('@/components/menuList/list/breakStockout')  /**缺货 */
const breakAisleFault = ()=> import('@/components/menuList/list/breakAisleFault')  /**货道故障 */


const machineCost = ()=> import('@/components/menuList/list/machineCost')  /**货道故障 */
const machineTest = ()=> import('@/components/menuList/list/machineTest')  /**机器测试 */
const machineProfitList = ()=> import('@/components/menuList/list/machineProfitList')  /**利润统计 */

Vue.use(Router)

const routes = [
  {path:'/',redirect:'/home',component:home},
  {path:"/home",name:"home",component:home,meta:{title:"首页"}},
  {path:"/menuList",name:'menuList',component:menuList,meta:{title:"全部分类"}},
    {path:"/todayReport",name:"todayReport",component:todayReport,meta:{title:"今日报表"}},
    {path:"/monthReport",name:"monthReport",component:monthReport,meta:{title:"运营报表"}},

    {path:"/salesDetails",name:"salesDetails",component:salesDetails,meta:{title:"全部分类"}},

    {path:"/deliveryRecord",name:"deliveryRecord",component:deliveryRecord,meta:{title:"出货详情"}},
    {path:"/wxNotice",name:"wxNotice",component:wxNotice,meta:{title:"微信消息通知"}},


    {path:"/aisleConfig",name:"aisleConfig",component:aisleConfig,meta:{title:"货道配置"}},
      {path:"/aisleDetails",name:"aisleDetails",component:aisleDetails,meta:{title:"货道配置"}},
        {path:"/changeGoods",name:"changeGoods",component:changeGoods,meta:{title:"更改商品"}},

    {path:"/machineDetails",name:"machineDetails",component:machineDetails,meta:{title:"设备详情"}},
      {path:"/setLocation",name:"setLocation",component:setLocation,meta:{title:"设备详情"}},
      {path:"/paymentDetails",name:"paymentDetails",component:paymentDetails,meta:{title:"收支详情"}},
      {path:"/changeMachineInfo",name:"changeMachineInfo",component:changeMachineInfo,meta:{title:"设备详情"}},
      {path:"/machineCode",name:"machineCode",component:machineCode,meta:{title:"机器二维码"}},

    {path:"/replenishment",name:"replenishment",component:replenishment,meta:{title:"补货"}},
      {path:"/replenishmentDetails",name:"replenishmentDetails",component:replenishmentDetails,meta:{title:"补货"}},

    {path:"/dataAnalysis",name:"dataAnalysis",component:dataAnalysis,meta:{title:"数据分析"}},

    {path:"/salesStatistics",name:"salesStatistics",component:salesStatistics,meta:{title:"销售统计"}},
      {path:"/salesStatisticsDetails",name:"salesStatisticsDetails",component:salesStatisticsDetails,meta:{title:"销售统计"}},
      {path:"/accountRankList",name:"accountRankList",component:accountRankList,meta:{title:"运营商排名"}},
      {path:"/salesChart",name:"salesChart",component:salesChart,meta:{title:"销售趋势图"}},

    {path:"/noncash",name:"noncash",component:noncash,meta:{title:"雪糕机"}},
      {path:"/allocation",name:"allocation",component:allocation,meta:{title:"分配机器"}},

    {path:"/cashMachine",name:"cashMachine",component:cashMachine,meta:{title:"支付明细"}},
    {path:"/noCashDetail",name:"noCashDetail",component:noCashDetail,meta:{title:"销售支付明细"}},

    {path:"/stockMachine",name:"stockMachine",redirect:"/stockMachine/breakStockout",component:stockMachine,meta:{title:"雪糕机"},children:[
      {path:"/stockMachine/stockStatistics",name:"stockStatistics",component:stockStatistics,meta:{title:"缺货统计"}},
      {path:"/stockMachine/breakStockout",name:"breakStockout",component:breakStockout,meta:{title:"缺货统计"}},
    ]},

    {path:"/breakMachine",name:"breakMachine",redirect:"/breakMachine/breakMissing",component:breakMachine,meta:{title:"雪糕机"},children:[
      {path:"/breakMachine/breakMissing",name:"breakMissing",component:breakMissing},
      {path:"/breakMachine/breakAisleFault",name:"breakAisleFault",component:breakAisleFault},
    ]},
        {path:"/breakMissingDetails",name:"breakMissingDetails",component:breakMissingDetails,meta:{title:"失联详情"}},
        {path:"/breakStockoutDetails",name:"breakStockoutDetails",component:breakStockoutDetails,meta:{title:"缺货详情"}},
        {path:"/breakAisleFaultDetails",name:"breakAisleFaultDetails",component:breakAisleFaultDetails,meta:{title:"故障详情"}},

    {path:"/goodsList",name:"goodsList",component:goodsList,meta:{title:"商品列表"}},

    {path:"/addGoods",name:"addGoods",component:addGoods,meta:{title:"添加商品"}},
    {path:"/changeAlreadyGoods",name:"changeAlreadyGoods",component:changeAlreadyGoods,meta:{title:"修改商品"}},
     {path:"/machineCost",name:"machineCost",component:machineCost,meta:{title:"设置运营成本"}},
     {path:"/machineTest",name:"machineTest",component:machineTest,meta:{title:"机器测试"}},

  {path:"/setting",name:"setting",component:setting,meta:{title:"个人中心"}},
    {path:"/requestWithdrawal",name:"requestWithdrawal",component:requestWithdrawal,meta:{title:"申请提现"}},
    {path:"/renew",name:"renew",component:renew,meta:{title:"设备续费"}},
      {path:"/renewConfirm",name:"renewConfirm",component:renewConfirm,meta:{title:"续费支持"}},
      {path:"/pay/renewBlank",name:"renewBlank",component:renewBlank,meta:{title:"续费支持"}},
    {path:"/changeBind",name:"changeBind",component:changeBind,meta:{title:"更改绑定"}},
    {path:"/feedback",name:"feedback",component:feedback,meta:{title:"问题反馈"}},
    {path:"/changePassword",name:"changePassword",component:changePassword,meta:{title:"修改密码"}},
    {path:"/withdrawDepositRecord",name:"withdrawDepositRecord",component:withdrawDepositRecord,meta:{title:"提现记录"}},

    {path:"/service",name:"service",component:service,meta:{title:"客服管理"}},
    {path:"/reple",name:"reple",component:reple,meta:{title:"客服管理"}},

    {path:"/vip",name:"vip",component:vip,meta:{title:"会员卡"}},
    {path:"/vipDetails",name:"vipDetails",component:vipDetails,meta:{title:"会员卡"}},
    {path:"/cardReissue",name:"cardReissue",component:cardReissue,meta:{title:"会员卡"}},
    {path:"/recharge",name:"recharge",component:recharge,meta:{title:"会员卡"}},
    {path:"/addVip",name:"addVip",component:addVip,meta:{title:"会员卡"}},

    {path: '/machineProfitList',name: "machineProfitList",component:machineProfitList,meta:{title:"利润统计"}},

    {path:"/404",name:"not404",component:not404,meta:{title:"404"}},
    {path:"/505",name:"not505",component:not505,meta:{title:"505"}},

    {path: '/login',name: "login",component:login,meta:{title:"登录"}},
    {path:'*',redirect:'/'}
]

const router = new Router({
  routes,
  mode:'history',
  linkActiveClass:'active'  //设置路由激活时的样式名
})

const originalPush = Router.prototype.push /**去除重名跳转报错 */
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js